import React from "react";
import useReveal from "../hooks/useReveal";
import { cx } from "../lib/ui";

/**
 * Scroll-triggered reveal.
 * Default: fade and rise. `mask` clips instead, so a line of type
 * appears from behind its own baseline — used for the headlines.
 */
export default function Reveal({
  as: Tag = "div",
  mask = false,
  delay = 0,
  className = "",
  children,
  ...rest
}) {
  const [ref, isIn] = useReveal();
  const style = { transitionDelay: `${delay}ms`, ...(rest.style || {}) };

  if (mask) {
    return (
      <Tag ref={ref} {...rest} className={cx("block overflow-hidden", className)}>
        <span
          className={cx(
            "block transition-transform duration-[1050ms] ease-out",
            isIn ? "translate-y-0" : "translate-y-full"
          )}
          style={style}
        >
          {children}
        </span>
      </Tag>
    );
  }

  return (
    <Tag
      ref={ref}
      {...rest}
      style={style}
      className={cx(
        "transition-[opacity,transform] duration-[900ms] ease-out",
        isIn ? "translate-y-0 opacity-100" : "translate-y-7 opacity-0",
        className
      )}
    >
      {children}
    </Tag>
  );
}
